import * as yup from 'yup';
import { eUSAState } from '../../ui-toolkit/enums/states';

const addressSchema = yup.lazy((value) => {
  const { streetAddress, unit, city, stateAbbreviation, zipCode } = value;
  const isAnyFieldPopulated = streetAddress || unit || city || stateAbbreviation || zipCode;

  if (isAnyFieldPopulated) {
    return yup.object().shape({
      streetAddress: yup.string().required(),
      unit: yup.string().nullable(),
      city: yup.string().required(),
      stateAbbreviation: yup.mixed<eUSAState>().required(),
      zipCode: yup.string().min(5).required(),
    });
  } else {
    return yup.object().shape({
      streetAddress: yup.string().nullable(),
      unit: yup.string().nullable(),
      city: yup.string().nullable(),
      stateAbbreviation: yup.mixed<eUSAState>().nullable(),
      zipCode: yup.string().min(5).nullable(),
    });
  }
});

const brokerageAgentScheme = yup.object({
  firmName: yup.string().nullable(),
  address: addressSchema,
});

export const updateBrokerageAgentsScheme = yup.object({
  buyerAgent: brokerageAgentScheme,
  sellerAgent: brokerageAgentScheme,
});

export const updateContractualDatesAndExpensesScheme = yup.object().shape({
  emdHolder: yup.string().nullable(),
  isDueDateRequired: yup.boolean(),
  emdDueDate: yup
    .string()
    .nullable()
    .when('isDueDateRequired', {
      is: true,
      then: yup.string().nullable().required('Due Date is required'),
    }),
  isDueDiligenceDateRequired: yup.boolean(),
  dueDiligenceDate: yup
    .string()
    .nullable()
    .when('isDueDiligenceDateRequired', {
      is: true,
      then: yup.string().nullable().required('Due Diligence Date is required'),
    }),
  dueDiligenceDays: yup
    .number()
    .integer()
    .nullable()
    .when('isDueDiligenceDateRequired', {
      is: true,
      then: yup.number().integer().nullable().required('Number Of Days is required'),
    }),
});

export const updatePropertyTitleScheme = yup.object({
  apn: yup.string().nullable(),
});
